import inspirationsController from './inspirationsController'

export default inspirationsController



// WEBPACK FOOTER //
// ../src/controllers/inspirationsController/index.js